import DashboardIcon from '@repo/ui/components/icons/sidebar/DashboardIcon';
import MaintenanceIcon from '@repo/ui/components/icons/sidebar/MaintanceIcon';
// import MessagesIcon from '@/components/icons/sidebar/messages';
import SupportIcon from '@repo/ui/components/icons/sidebar/ChatIcon';
import TwoUsersIcon from '@repo/ui/components/icons/sidebar/TwoUsersIcon';
import AddClient from '@repo/ui/components/icons/AddClient';
import UsersIcon from '@repo/ui/components/icons/sidebar/UsersIcon';
import LocationIcon from '@repo/ui/components/icons/sidebar/LocationIcon';
import People from '@repo/ui/components/icons/People';
import { BarChart3, CircleDollarSign, Package, Package2 } from 'lucide-react';

export const navigationBottom = [
    // { name: 'messages', icon: MessagesIcon, activeIcon: MessagesIcon, to: '' },
    {
        name: 'settings',
        icon: MaintenanceIcon,
        activeIcon: MaintenanceIcon,
        to: '/settings',
    },
    // { name: 'help_and_support', icon: SupportIcon, activeIcon: SupportIcon, to: '' },
];

export const studentRelations = [
    {
        name: 'add_client',
        to: '/members/add-member',
    },
    { name: 'member_communication', to: '/members/member-communication' },
];

// // Service
export const ReportsSide = [
    { name: 'members', to: '/reports/member' },
    { name: 'marketing', to: '/reports/marketing' },
    {
        name: 'packages_and_products',
        to: '/reports/packages-and-products',
    },
    {
        name: 'branches_and_employees',
        to: '/reports/branches-and-employees',
    },

];

export const navigation = [
    { name: 'dashboard', icon: DashboardIcon, activeIcon: DashboardIcon, to: '/' },
    {
        name: 'members',
        icon: TwoUsersIcon,
        activeIcon: TwoUsersIcon,
        to: '/members',
        navigation: studentRelations,
    },

    {
        name: 'packages',
        icon: Package2,
        activeIcon: Package2,
        to: '/packages',
        // requiresPermission: 'list_service',
    },
    {
        name: 'products',
        icon: Package,
        activeIcon: Package,
        to: '/products',
        // requiresPermission: 'product',
    },

    {
        name: 'order',
        icon: AddClient,
        activeIcon: AddClient,
        to: '/subscriptions',
        // requiresPermission: 'list_order',
    },
    // {
    //     name: 'customer_by_type',
    //     icon: ShoppingCart,
    //     activeIcon: ShoppingCart,
    //     to: '/sales',
    //     requiresPermission: 'list_customer',
    // },
    {
        name: 'marketing',
        to: '/marketing',
        icon: TwoUsersIcon,
        activeIcon: TwoUsersIcon,
        // requiresPermission: 'list_marketing',
    },
    {
        name: 'employees',
        icon: UsersIcon,
        activeIcon: UsersIcon,
        to: 'employees/employe',
        // requiresPermission: 'list_user',
    },
    {
        name: 'branches',
        icon: LocationIcon,
        activeIcon: LocationIcon,
        to: '/branches',
    },
    {
        name: 'finance',
        icon: CircleDollarSign,
        activeIcon: CircleDollarSign,
        to: '/finance',
        // requiresPermission: 'list_finance',
    },
    {
        name: 'reports',
        icon: BarChart3,
        activeIcon: BarChart3,
        to: '/reports',
        navigation: ReportsSide,
        // requiresPermission: 'list_report',
    },
    {
        name: 'permissions',
        icon: LocationIcon,
        activeIcon: LocationIcon,
        to: '/permissions-page',
    },
];
